
import ProductTile from './M04-ProductTile/ProductTile.vue'
import FilterPager from '../M02-ShopFilter/components/FilterPager/FilterPager.vue'
import ShopFilter from '../M02-ShopFilter/ShopFilter.vue'
import SortDropdown from './SortDropdown/SortDropdown.vue'

export default {
    name: 'product-tile-grid',
    data(){
        return {
            searchConfig : {
                skip: 0,
                take: 1,
                puid: '22ae6b81-0a19-4d91-ade0-79b86f870ecb',
                language: "da"
            },
        }
    },
    computed:{
        productCards() {
            if (this.$store.state.search.results) {
                return this.$store.state.search.results
            }
        }
    },
    methods: {
    },
    components: {
        ProductTile,
        FilterPager,
        SortDropdown,
        ShopFilter
    }
}